import { render, staticRenderFns } from "./portals.vue?vue&type=template&id=6d889279&scoped=true&lang=pug&"
import script from "./portals.vue?vue&type=script&lang=js&"
export * from "./portals.vue?vue&type=script&lang=js&"
import style0 from "./portals.vue?vue&type=style&index=0&id=6d889279&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d889279",
  null
  
)

export default component.exports